import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Container} from 'react-bootstrap';
import { globalUpdateState,saveData } from '../redux/actions';
import StepsNav from './StepsNav';
import Templates from './Templates';
// import Summary from './Summary';
import { animateScroll as scroll } from 'react-scroll';
import Intro from './Intro';
import Step1 from './Client/Step1';
import Step2 from './Client/Step2';
import Step3 from './Client/Step3';
import Step4 from './Client/Step4';
import Step5 from './Client/Step5';
import Step6 from './Client/Step6';
import Step7 from './Client/Step7';
import Step8 from './Client/Step8';
import Step9 from './Client/Step9';
import Dialog from './Dialog';

import ProcessData from './ProcessData';
import Report from './Reports/Report';
import Constants from './Constants';
import CKEditor from './CKEditor/CKEditor';
import axios from 'axios';
import { PromptDialog } from './Dialog/Message';
/* eslint react/prop-types: 0 */

class Wizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: props.currentStep || 0, // 0 mean intial state
      firstStep: 1,
      lastStep: 9,
      totalSteps: 9,
      stepsOpened: props.stepsOpened || 0,
      form: props.form,
      response: {},
      isProcessing: false,
      currentTemplate: ''
    };
    this.getForm = this.getForm.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.goToStep = this.goToStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.getStepHeader = this.getStepHeader.bind(this);
    this.processResult = this.processResult.bind(this);
    this.reset = this.reset.bind(this);
    this.reset92Know = this.reset92Know.bind(this);
  }
  UNSAFE_componentWillUpdate() {
    return true;
  }
  nextStep(shouldContinue) {
    let currentStep = this.state.currentStep;
    if (currentStep < this.state.stepsOpened) {
      if (shouldContinue === 'continue') currentStep = ++currentStep;
      else currentStep = this.state.stepsOpened;
    } else currentStep = ++currentStep;
    this.setState({ currentStep: currentStep, stepsOpened: currentStep }, () =>
      setTimeout(() => {
        scroll.scrollToBottom();
      }, 500)
    );
  }
  previousStep() {
    let currentStep = this.state.currentStep;
    if (currentStep > 0) {
      this.setState({ currentStep: --currentStep });
    }
  }
  goToStep(step) {
    this.setState({ currentStep: step });
  }
  updateForm = async (value, key) => {
    // let form = this.state.form;
    let form = this.props.form;
    form[key] = { ...form[key], ...value };
    // this.setState({ form });
    form.currentStep = this.state.currentStep;
    form.stepsOpened = this.state.stepsOpened;
    this.props.saveData(form);
    // console.log('update form',this.state);
  };
  getStepHeader(currentStep) {
    currentStep = currentStep - 1;
    let str = Constants.HeaderTexts.Single[currentStep];
    // let form = this.state.form;
    let form = this.props.form;
    if (form && form.client && form.client.isMarried === 'true') {
      str = Constants.HeaderTexts.Married[currentStep];
    }
    // return <h5 className="">{str}</h5>;
    return <p dangerouslySetInnerHTML={{ __html: str }} />;
  }
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  updateResponse = async (value, key) => {
    let response = this.state.response;
    response = { ...value };
    this.setState({ response: response, isProcessing: 'report' });
    // console.log('update response',this.state);
  };
  processResult(status) {
    if (!status) {
      this.setState({ isProcessing: status, response: {} });
    } else if (status === 'process') {
      this.setState({ isProcessing: status });
    } else {
      let currentStep = this.state.currentStep;
      currentStep = ++currentStep;
      this.setState({ isProcessing: status, currentStep: currentStep, stepsOpened: currentStep });
    }
  }
  // Do something on step change
  onStepChange = stats => {
    // console.log(stats);
  };
  getForm(key = 'form') {
    if (key === 'form') return this.props[key];
    else {
      return this.state[key];
    }
  }
  reset() {
    this.child.handleShow(true);
  }
  reset92Know() {
    axios({
      method: 'post',
      url: '/92know/admin/data/reset'
    }).then(
      response => {
        let { data } = response;
        this.child.handleShow(false);
        if (data && data.success) {
          this.child.showMessage('9 To Know', data.message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          this.child.showMessage('9 To Know', data.message || 'Something went wrong!');
        }
      },
      error => {
        this.child.showMessage('9 To Know', 'Something went wrong!');
      }
    );
  }
  getStepComponent(step, props) {
    let comp = <div key={this.makeid(5)}></div>;
    switch (step) {
      case 0:
        comp = <Intro {...props} />;
        break;
      case 1:
        comp = <Step1 {...props} />;
        break;
      case 2:
        comp = <Step2 {...props} />;
        break;
      case 3:
        comp = <Step3 {...props} />;
        break;
      case 4:
        comp = <Step4 {...props} />;
        break;
      case 5:
        comp = <Step5 {...props} />;
        break;
      case 6:
        comp = <Step6 {...props} />;
        break;
      case 7:
        comp = <Step7 {...props} />;
        break;
      case 8:
        comp = <Step8 {...props} />;
        break;
      case 9:
        comp = <Step9 {...props} />;
        break;
      default:
        break;
    }
    return comp;
  }
  render() {
    let props = {
      currentStep: this.state.currentStep,
      firstStep: this.state.firstStep,
      stepsOpened: this.state.stepsOpened,
      goToStep: this.goToStep,
      lastStep: this.state.lastStep,
      nextStep: this.nextStep,
      previousStep: this.previousStep,
      totalSteps: this.state.totalSteps,
      getForm: this.getForm,
      upliftState: this.updateForm,
      updateResponse: this.updateResponse,
      getStepHeader: this.getStepHeader,
      closeStep: this.closeStep,
      processResult: this.processResult,
      isProcessing: this.state.isProcessing
    };
    let steps = [Intro, Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8, Step9, 'Summary', ProcessData, Report];
    const isProcessing = this.state.isProcessing;
    const buttonComp = <div className="cta">
      {this.getStepComponent(0, {
        key: `Step${this.makeid(5)}`,
        currentStep: 0,
        isActive: 0 === this.state.currentStep,
        ...props
      })}
    </div>;
    // if(!isProcessing)
    if (this.state.stepsOpened === 0) {
      return (
        <React.Fragment>
          <Templates props={this.props} buttonComp={buttonComp} />

          {/*<div className="row smheight home_92k template_2ui" style={{display: 'none'}}>*/}
          {/*  <div className={`col-md-6 col-sm-12`}>*/}
          {/*    <div className="editor_wrap">*/}
          {/*      <CKEditor type="topMid" height="330px"/>*/}
          {/*      <div className="cta">*/}
          {/*        {this.getStepComponent(0, {*/}
          {/*          key: `Step${this.makeid(5)}`,*/}
          {/*          currentStep: 0,*/}
          {/*          isActive: 0 === this.state.currentStep,*/}
          {/*          ...props*/}
          {/*        })}*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  <div className={`col-md-6 col-sm-12 `}>*/}
          {/*    <div className="img_92k">*/}
          {/*      <div className="left">*/}
          {/*        <CKEditor type="left"/>*/}
          {/*      </div>*/}
          {/*      <div className="right">*/}
          {/*        <CKEditor type="right"/>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </React.Fragment>
      );
    } else {
      return (
        <Container>
          <div className={'jumbotron ' + (!isProcessing || isProcessing === 'generate' ? '' : 'hidden')}>
            <div className="row">
              <div className={`col-md-12 col-sm-12 `}>
                {this.state.form.isAdvisor && (
                  <React.Fragment>
                    <button
                      type="button"
                      style={{marginTop: '-35px', marginBottom: '15px'}}
                      className="btn btn-primary float-right"
                      onClick={this.reset}
                    >
                      Reset
                    </button>
                    <PromptDialog
                      onRef={ref => (this.child = ref)}
                      title="Reset Changes"
                      okText="Yes"
                      cancelText="No"
                      isAgree={''}
                      body={
                        'This will reset your personal 9 to Know data, it will not affect any of your current prospect’s 9 to Know data. Do you want to proceed?'
                      }
                      onlyDialog={true}
                      onOk={this.reset92Know}
                    />
                  </React.Fragment>
                )}
                {this.state.currentStep > 0 && <StepsNav {...props} currentStep={this.state.currentStep}/>}
                {steps.map((step, index) => {
                  if (this.state.stepsOpened === 0 && index === 0) {
                    return null;
                    // return  this.getStepComponent(index,
                    //     {
                    //         key: `Step${this.makeid(5)}`,
                    //         currentStep:index,
                    //         isActive:(index === this.state.currentStep),
                    //         ...props
                    //     }
                    //     )
                  } else if (index <= this.state.stepsOpened && index !== 0) {
                    return this.getStepComponent(index, {
                      key: `Step${this.makeid(5)}`,
                      currentStep: index,
                      isActive: index === this.state.currentStep,
                      ...props
                    });
                  } else {
                    return null;
                  }
                })}
                <React.Fragment>
                  <br/>
                  {this.state.currentStep > 1 && (
                    // <button key={this.makeid(5)} className='btn btn-primary btn-md' onClick={e => {e.preventDefault(); this.finishLater()}} type="button">Finish Later</button>
                    <Dialog
                      mainbuttontext="Finish Later"
                      btnoktext="Send"
                      heading="Save & Finish Later"
                      description="Please enter your email for us to provide you with a link in order for you to complete your analysis."
                    />
                  )}
                  {(isProcessing === 'generate' || this.state.stepsOpened > this.state.totalSteps) && (
                    <button
                      key={this.makeid(5)}
                      style={{marginRight: '20px'}}
                      className="btn btn-primary btn-md float-right"
                      onClick={e => {
                        e.preventDefault();
                        this.processResult('process');
                      }}
                      type="button"
                    >
                      Generate
                    </button>
                  )}
                </React.Fragment>
              </div>
            </div>
          </div>
          {isProcessing === 'process' && (
            <div className={'jumbotron '}>
              <ProcessData isActive={true} {...props} />
            </div>
          )}
          {isProcessing === 'report' && (
            <div className={'jumbotron '}>
              <Report isActive={true} {...props} />
            </div>
          )}
        </Container>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  let {form} = state.mainState;
  return {
    renderMode: form.currentStep > 0 ? 1 : 0,
    currentStep: form.currentStep > 0 ? form.currentStep + 1 : 0,
    stepsOpened: form.stepsOpened > 0 ? form.stepsOpened + 1 : 0,
    form: form,
    ...ownProps
  };
};

const mapDispatchToProps = {
  globalUpdateState,
  saveData: saveData
};
export default connect(mapStateToProps, mapDispatchToProps)(Wizard);
